module.exports = __webpack_public_path__ + "i18n/pt-BR.6401b2fdb77651b340f92edad0543c71.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pt-BR.json
// module id = 1314
// module chunks = 59